import apiClient from '../axios.js'

/**
 * 方案模組關聯管理 API
 */
export const planModuleService = {
  /**
   * 獲取方案的模組列表
   * @param {string} planId - 方案 ID
   * @returns {Promise<Object>} 模組列表
   */
  getModulesByPlanId: async (planId) => {
    const response = await apiClient.get(`/system/plans/${planId}/modules`)
    return response
  },

  /**
   * 批量添加模組到方案
   * @param {string} planId - 方案 ID
   * @param {Array<string>} moduleIds - 模組 ID 列表
   * @returns {Promise<Object>} 添加結果
   */
  addModules: async (planId, moduleIds) => {
    const response = await apiClient.post(`/system/plans/${planId}/modules`, {
      moduleIds
    })
    return response
  },

  /**
   * 從方案移除模組
   * @param {string} planId - 方案 ID
   * @param {string} moduleId - 模組 ID
   * @returns {Promise<Object>} 移除結果
   */
  removeModule: async (planId, moduleId) => {
    const response = await apiClient.delete(`/system/plans/${planId}/modules/${moduleId}`)
    return response
  },

  /**
   * 查詢模組的方案列表
   * @param {string} moduleId - 模組 ID
   * @returns {Promise<Object>} 方案列表
   */
  getPlansByModuleId: async (moduleId) => {
    const response = await apiClient.get(`/system/modules/${moduleId}/plans`)
    return response
  },

  /**
   * 批量更新方案的模組（先清空再添加）
   * @param {string} planId - 方案 ID
   * @param {Array<string>} moduleIds - 模組 ID 列表
   * @returns {Promise<Object>} 更新結果
   */
  updatePlanModules: async (planId, moduleIds) => {
    // 先獲取當前模組列表
    const currentModules = await apiClient.get(`/system/plans/${planId}/modules`)
    
    // 修正：後端回應的是 moduleId，不是 id
    const currentModuleIds = currentModules.data?.map(m => m.moduleId) || []

    // 找出需要移除的模組
    const toRemove = currentModuleIds.filter(id => !moduleIds.includes(id))
    // 找出需要添加的模組
    const toAdd = moduleIds.filter(id => !currentModuleIds.includes(id))

    console.log('📝 更新方案模組:', { 移除: toRemove.length, 新增: toAdd.length });

    // 執行移除
    for (const moduleId of toRemove) {
      await apiClient.delete(`/system/plans/${planId}/modules/${moduleId}`)
    }

    // 執行添加
    if (toAdd.length > 0) {
      await apiClient.post(`/system/plans/${planId}/modules`, {
        moduleIds: toAdd
      })
    }

    return {
      success: true,
      message: '模組關聯更新成功',
      data: {
        added: toAdd.length,
        removed: toRemove.length
      }
    }
  }
}
